import { render, staticRenderFns } from "./ClipLoader.vue?vue&type=template&id=274f5aae&"
import script from "./ClipLoader.vue?vue&type=script&lang=js&"
export * from "./ClipLoader.vue?vue&type=script&lang=js&"
import style0 from "./ClipLoader.vue?vue&type=style&index=0&id=274f5aae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports